import { FC } from 'react';

import { Stack, Typography } from '@mui/material';

import useLocales from '@src/locales/use-locales';

import ForgotPasswordForm from '../forgot-password-form';

type ResetPasswordProps = {
  goToStep: (index: number) => void;
};

const ResetPassword: FC<ResetPasswordProps> = (props) => {
  const { goToStep } = props;
  const { t } = useLocales();
  return (
    <>
      <Stack justifyContent="center" alignItems="center" spacing={2}>
        <Typography variant="subtitle1" color="primary">
          {t('forgotPassword.title')}
        </Typography>
        <Typography variant="body1">
          {t('forgotPassword.enterEmailAddress', { ns: 'common' })}
        </Typography>
      </Stack>
      <ForgotPasswordForm goToStep={goToStep} />
    </>
  );
};

export default ResetPassword;
